import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Display from "../display/Display";

type TabType = "products" | "contents";

const Tabs: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = (searchParams.get("role") as TabType) || "products";

  useEffect(() => {
    if (!searchParams.get("role")) {
      setSearchParams({ role: "products" });
    }
  }, [searchParams, setSearchParams]);

  const handleTabChange = (tab: TabType) => {
    setSearchParams({ role: tab });
  };

  return (
    <section className="flex flex-col items-center space-y-5 md:items-start md:space-y-10">
      {/* Tab Buttons */}
      <div className="flex space-x-4 my-8">
        <button
          className={`px-6 py-2 rounded-md ${
            activeTab === "products"
              ? "bg-blue-300 text-black font-bold"
              : "bg-gray-200"
          }`}
          onClick={() => handleTabChange("products")}
        >
          Products
        </button>
        <button
          className={`px-6 py-2 rounded-md ${
            activeTab === "contents"
              ? "bg-blue-300 text-black font-bold"
              : "bg-gray-200"
          }`}
          onClick={() => handleTabChange("contents")}
        >
          Contents
        </button>
      </div>

      {/* Tab Content */}
      <Display activeTab={activeTab} />
    </section>
  );
};

export default Tabs;
